/**
 * Pre-compiled fr-FR messages for Dialog
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Fermer la boîte de dialogue` };
